export interface Track {
  title: string
  artist: string
  thumbnail: string
  soundcloudUrl: string
  soundcloudId?: number
}

export const tracks: Track[] = [
  {
    title: "Valzer d'Inverno",
    artist: 'Andrea Vanzo',
    thumbnail: '/images/songs/song_1.jpg',
    soundcloudUrl: 'https://soundcloud.com/andrea-vanzo/valzer-dinverno?si=2f4ee303039749829a6312b1d83f1853&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing'
  },
  {
    title: 'Comptine d\'un autre été',
    artist: 'Yann  Tiersen',
    thumbnail: '/images/songs/song_2.jpg',
    soundcloudUrl: 'https://soundcloud.com/xkuruma/comptine-dun-autre-ete-yann-tiersen?si=abad0fa36c0a4789b0b5392aef906455&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing'
  },
  {
    title: 'Married Life (Up song)',
    artist: 'Michael Giacchino',
    thumbnail: '/images/songs/song_3.jpg',
    soundcloudUrl: 'https://soundcloud.com/thewildconductor/disney-pixars-up-theme-married-life-piano-version?si=7c5b4fd3c3d94f67a343de84316c34a1&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing'
  }
]